import { render, staticRenderFns } from "./WbgtAndHeatIndex.vue?vue&type=template&id=22a9adb4&scoped=true&"
import script from "./WbgtAndHeatIndex.vue?vue&type=script&lang=ts&"
export * from "./WbgtAndHeatIndex.vue?vue&type=script&lang=ts&"
import style0 from "./WbgtAndHeatIndex.vue?vue&type=style&index=0&id=22a9adb4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a9adb4",
  null
  
)

export default component.exports